module.exports = __webpack_public_path__ + "static/media/gl-logo.3b86bea3.png";